module.exports = kolibriCoreAppGlobal.coreVue.components.CoreLogo;